import { useState } from "react";
import DeviceManagementService from "../services/api/device-management-service"
import { useSnackbar } from "notistack";
import useDeviceStore from "../zustand/useDeviceStore";


export const useDeviceManagement = () => {


    const [list, setList] = useState([]);
    const [isLoadingDevice, setIsLoadingDevice] = useState(false);
    const [isUpdatingDevice, setIsUpdatingDevice] = useState(false);
    const [isUpdatingEntryType, setIsUpdatingEntryType] = useState(false);
    const [filterList, setFilterList] = useState([]);

    const {enqueueSnackbar} = useSnackbar();
    const {setDeviceUpdated} = useDeviceStore();


    const deviceList = (parameters) => {
        setIsLoadingDevice(true);
        setDeviceUpdated(false)
        DeviceManagementService.deviceList(parameters).then((res)=>{
            console.log('device list data res aaaa', res)
            setIsLoadingDevice(false);
            setList(res.data.data);
        }).catch((error)=> {
            setIsLoadingDevice(false);
           const errorMessage = error?.response?.data?.error || error.message;
            enqueueSnackbar(errorMessage, {
                variant: "error",
                autoHideDuration: 4000
            })
        })
    }

    const updateDeviceStatus = (parameters, setOpen) => {
        setIsUpdatingDevice(true)
        DeviceManagementService.updateDeviceStatus(parameters).then((res)=>{
            console.log('updateDeviceStatus data res aaaa', res);
            setOpen(false)
            setIsUpdatingDevice(false);
            setDeviceUpdated(true)
            window.location.reload()
        }).catch((error)=> {
            setIsUpdatingDevice(false)
            console.log('updateDeviceStatus data err errrr', error)
            const errorMessage = error?.response?.data?.error || error.message;
            setDeviceUpdated(false)
            enqueueSnackbar(errorMessage, {
                variant: "error",
                autoHideDuration: 4000
            })
        })
    }

    const updateDevice = (parameters, payload, setOpen) => {
        setIsUpdatingDevice(true)
        DeviceManagementService.updateDevice(parameters, payload).then((res)=>{
            console.log('updateDevicedata res aaaa', res);
            setOpen(false)
            setIsUpdatingDevice(false)
            setDeviceUpdated(true)
            enqueueSnackbar('Device updated', {
                variant: "success",
                autoHideDuration: 4000
            })
        }).catch((error)=> {
            setIsUpdatingDevice(false)
            console.log('updateDevice data err errrr', error)
            const errorMessage = error?.response?.data?.error || error.message;
            setDeviceUpdated(false)
            enqueueSnackbar(errorMessage, {
                variant: "error",
                autoHideDuration: 4000
            })
        })
    }

    const updateEntryType = (parameters, setOpen) => {
         DeviceManagementService.updateEntryType(parameters).then((res)=>{
            console.log('updateEntryType data res aaaa', res);
            setOpen(false)
            setIsUpdatingEntryType(false)
            window.location.reload()
        }).catch((error)=> {
            setIsUpdatingEntryType(false)
            console.log('updateEntryType data err errrr', error)
            const errorMessage = error?.response?.data?.error || error.message;

            enqueueSnackbar(errorMessage, {
                variant: "error",
                autoHideDuration: 4000
            })
        })
    }
    
    const filterDeviceList = (parameters) => {
        setIsLoadingDevice(true)
        DeviceManagementService.filterDeviceList(parameters).then((res)=>{
            console.log('device list data res aaaa', res)
            setIsLoadingDevice(false)
            setFilterList(res.data.data)
        }).catch((err)=> {
            setIsLoadingDevice(false)
            console.log('device list data err errrr', err)
        })
    }

    return{deviceList, list, isLoadingDevice, isUpdatingDevice, updateDeviceStatus, updateDevice, updateEntryType, isUpdatingEntryType, filterDeviceList, filterList}

}
